import script from "./DashboardLocationsStatistics.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardLocationsStatistics.vue?vue&type=script&setup=true&lang=js"

import "./DashboardLocationsStatistics.vue?vue&type=style&index=0&id=ce921a42&lang=css"

const __exports__ = script;

export default __exports__